import React, { memo } from 'react'
import { Scrollbar } from '../scrollbar'
import { Card, Table, TableBody } from '@mui/material'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useTheme } from '@emotion/react'

import { TableHeadCustom, TableNoData, TableSkeleton } from '../table'
import {
  NUMBER_OF_TX_PER_PAGE,
  TRANSACTION_STATUS_LABEL
} from '../../constants/transactions'
import TransactionRow from './TransactionRow'
import { LoadingScreen } from '../loading-screen'
import { formatTransaction } from '../../util/transactionRow.helpers'
import customConfig from 'customConfig'

const TransactionsTable = ({
  t,
  sx,
  loading,
  tableHeaders,
  transactions,
  tokenProfile,
  accountProfile,
  onShowFuturePointsInfo,
  scrollDataProps,
  ...other
}) => {
  const theme = useTheme()
  return (
    <Card sx={sx} {...other}>
      {loading ? (
        <DataLayout tableHeaders={tableHeaders}>
          <TableSkeleton
            rowCount={NUMBER_OF_TX_PER_PAGE}
            cellCount={tableHeaders.length}
            sx={{ height: 69 }}
          />
        </DataLayout>
      ) : !transactions.length && !loading ? (
        <DataLayout tableHeaders={tableHeaders}>
          <TableNoData
            icon={customConfig.transactionsIcon}
            description={t(customConfig.noTransactionsLabel)}
          />
        </DataLayout>
      ) : (
        <InfiniteScroll
          dataLength={transactions.length}
          loader={<LoadingScreen sx={{ my: { xs: 2, md: 3 } }} />}
          {...scrollDataProps}
        >
          <DataLayout tableHeaders={tableHeaders}>
            {transactions.map((transaction, index) => {
              const { status, isNft, ...restProps } = formatTransaction(
                transaction,
                t,
                tokenProfile,
                accountProfile.authId
              )
              const isFutureReward = status === TRANSACTION_STATUS_LABEL.FUTURE
              return (
                <TransactionRow
                  t={t}
                  key={index}
                  theme={theme}
                  onClick={() =>
                    isFutureReward ? onShowFuturePointsInfo(isNft) : null
                  }
                  anchor={isFutureReward}
                  status={status}
                  {...restProps}
                />
              )
            })}
          </DataLayout>
        </InfiniteScroll>
      )}
    </Card>
  )
}

export default memo(TransactionsTable)

const DataLayout = ({ tableHeaders, children }) => {
  return (
    <Scrollbar sx={{ minHeight: 100 }}>
      <Table sx={{ minWidth: 720 }}>
        <TableHeadCustom headCells={tableHeaders} />
        <TableBody>{children}</TableBody>
      </Table>
    </Scrollbar>
  )
}
